module.exports = __webpack_public_path__ + "img/icon.7f8d33da.svg";